module.exports = "/_next/static/images/wyoming-a8fbc2115cecf6f6e679f8a72705ab62.svg";